import script from "./manualReportingModel.vue?vue&type=script&setup=true&lang=js"
export * from "./manualReportingModel.vue?vue&type=script&setup=true&lang=js"

import "./manualReportingModel.vue?vue&type=style&index=0&id=91621d36&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91621d36"]])

export default __exports__